import styled from '@emotion/styled';
import { telebetColors } from 'src/assets/colors';
import Selection from 'src/components/Selection/Selection';

export const MatchBetTitle = styled('h4', { label: 'MatchBetTitle' })`
    font-size: 20px;
    line-height: 1.4;
`;

export const MatchBetMarketTitle = styled('h5', { label: 'MatchBetMarketTitle' })`
    display: flex;
    align-items: center;
    width: 100%;
    background-color: ${telebetColors.matchBet.bgColorMarketTitle};
    color: ${telebetColors.txtColor};
    margin: 0;
    padding: 5px;
    cursor: pointer;
`;

export const MatchBetMarketWrapper = styled('div', { label: 'MatchBetMarketWrapper' })`
    display: flex;
    flex-wrap: wrap;
    border: 2px solid ${telebetColors.matchBet.bgColorMarketTitle};
`;

interface QuickPickDetailsPropsType {
    nonRunner: boolean;
}

export const MatchBetSelectionWrapper = styled('div', { label: 'MatchBetSelectionWrapper' })<QuickPickDetailsPropsType>`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    padding-left: 6px;
    border-bottom: 1px solid ${telebetColors.matchBet.bgColorMarketTitle};
    color: ${({nonRunner}): string => nonRunner === true ? '#fff' : 'inherit'};
`;

export const RowCel = styled('div', { label: 'RowCel' })`
    padding: 6px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
    line-height: 1.2;
    border-right: 1px solid ${telebetColors.matchBet.bgColorMarketTitle};
`;

export const RowCelPlace = styled(RowCel, { label: 'RowCelPlace' })`
    font-size: 10px;
    text-align: center;
    width: 24px;
`;

export const RowCelName = styled(RowCel, { label: 'RowCelName' })`
    flex: 1 1 100%;
    font-size: 12px;
`;

export const AdditionalInfo = styled('span', { label: 'AdditionalInfo' })`
    display: block;
    width: 100%;
    font-size: 10px;
    color: ${telebetColors.txtColorMeta};
`;

export const SelectionMatchBet = styled(Selection, { label: 'SelectionMatchBet' })`
    width: 68px;
    
    &:hover {
    background-color: ${telebetColors.bgColorSelectionHover};
    }
`;
